import axios, { AxiosRequestConfig } from 'axios';

const baseUrl = import.meta.env.VITE_API_ENDPOINT + '/api';

export default class API {
  _put(url: string, data: any, config: AxiosRequestConfig = {}) {
    const requestUrl = `${baseUrl}${url}/`;
    return axios
      .put(requestUrl, data, config)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  _get<Response = any>(url: string, config: AxiosRequestConfig = {}) {
    let requestUrl = `${baseUrl}${url}`;
    if (!url.includes('?')) {
      requestUrl += '/';
    }

    return axios
      .get<Response>(requestUrl, config)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  _post<Request = any, Response = any>(
    url: string,
    data: Request,
    config: AxiosRequestConfig = {},
  ) {
    const requestUrl = `${baseUrl}${url}`;

    return axios
      .post<Response>(requestUrl, data, config)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }

  _delete(url: string, config: AxiosRequestConfig = {}) {
    const requestUrl = `${baseUrl}${url}/`;

    return axios
      .delete(requestUrl, config)
      .then((response) => response)
      .catch((error) => {
        throw error;
      });
  }
}
